export default __webpack_public_path__ + "static/media/platformer.33e123e2.png";